(() => {
  if (window.FXLDesktopPurchaseCard) return;
  const desktop = window.matchMedia('(min-width: 990px)');
  const controllers = new Map();
  const overlaps = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  function initialize(root) {
    if (controllers.has(root)) return;
    const card = root.querySelector('[data-sticky-bar]');
    const button = root.querySelector('[data-add-button]');
    const form = root.querySelector('[data-product-form]');
    const cardButton = root.querySelector('[data-sticky-add]');
    const modelLink = root.querySelector('[data-desktop-card-model]');
    if (!card || !button) return;
    const footer = document.querySelector('footer.mry-footer');
    const header = document.querySelector('.section-header');
    let frame = 0;
    let observer;
    let pending = false;
    let mobileIntersection = null;
    const visible = (show) => {
      if (window.FXLProductMotion) window.FXLProductMotion.setVisible(card, show);
      else {
        card.hidden = !show;
        card.inert = !show;
        card.classList.toggle('is-visible', show);
      }
    };
    const update = () => {
      frame = 0;
      if (!desktop.matches || !root.isConnected) return;
      // Read geometry together, then update styles; one pass per animation frame.
      const buttonRect = button.getBoundingClientRect();
      const headerRect = header?.getBoundingClientRect();
      const topBoundary = Math.max(0, Math.min(headerRect?.bottom || 0, 160));
      const footerTop = footer?.getBoundingClientRect().top ?? Infinity;
      const cardRect = card.getBoundingClientRect();
      const focused = document.activeElement;
      // Theme page-entry focus on <main tabindex="-1"> is not an obscured control.
      const focusedControl = focused?.matches('a[href],button,input,select,textarea,summary,[tabindex]:not([tabindex="-1"])');
      const focusRect = focusedControl && !card.contains(focused) ? focused.getBoundingClientRect() : null;
      const focusCovered = focusRect && focusRect.width > 0 && overlaps(cardRect, focusRect);
      const overlayOpen = document.documentElement.matches('.mry-header-search-open,.mry-mobile-nav-open,.fxl-catalog-filter-lock');
      let bottom = 24;
      let chatOpen = false;
      document.querySelectorAll('iframe[title],iframe[aria-label],shopify-chat').forEach((chat) => {
        const label = `${chat.getAttribute('title') || ''} ${chat.getAttribute('aria-label') || ''} ${chat.tagName}`;
        if (!/chat|support|inbox/i.test(label)) return;
        const r = chat.getBoundingClientRect();
        if (!r.width || !r.height || r.left >= innerWidth || r.top >= innerHeight || r.right < innerWidth - 180) return;
        if (r.height > 320) chatOpen = true;
        else bottom = Math.max(bottom, innerHeight - r.top + 12);
      });
      card.style.setProperty('--fxl-purchase-card-bottom', `${bottom}px`);
      const pastPurchase = buttonRect.bottom <= topBoundary;
      const beforeFooter = footerTop > innerHeight + 24;
      visible(pastPurchase && beforeFooter && !overlayOpen && !chatOpen && !focusCovered);
    };
    const schedule = () => {
      if (!desktop.matches || frame) return;
      frame = requestAnimationFrame(update);
    };
    const onViewport = () => {
      if (desktop.matches) schedule();
      else {
        cancelAnimationFrame(frame); frame = 0;
        card.style.removeProperty('--fxl-purchase-card-bottom');
        // Restore the original mobile rule, including before the primary CTA enters view.
        if (mobileIntersection !== null) visible(!mobileIntersection);
      }
    };
    const onSubmit = (event) => {
      if (!desktop.matches || event.defaultPrevented || !root.querySelector('[data-variant-id]')?.value) return;
      pending = true;
      card.setAttribute('aria-busy', 'true');
      if (cardButton) cardButton.textContent = 'Adding…';
    };
    const onModelClick = (event) => {
      if (!desktop.matches || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !form) return;
      event.preventDefault();
      form.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      form.querySelector('[data-option-input]:checked:not(:disabled)')?.focus({preventScroll: true});
    };
    const onPageShow = (event) => {
      if (desktop.matches && event.persisted && pending) {
        const id = root.querySelector('[data-variant-id]')?.value;
        const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
        const variant = variants.find((v) => String(v.id) === String(id));
        if (cardButton) { cardButton.disabled = !variant?.available; cardButton.textContent = variant?.available ? 'Add to cart' : 'Sold out'; }
        button.disabled = !variant?.available;
        const label = root.querySelector('[data-add-label]');
        if (label) label.textContent = variant?.available ? 'Add to cart' : 'Sold out';
        form?.removeAttribute('aria-busy');
        card.removeAttribute('aria-busy');
        pending = false;
      }
      schedule();
    };
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('pageshow', onPageShow);
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    desktop.addEventListener('change', onViewport);
    form?.addEventListener('submit', onSubmit);
    modelLink?.addEventListener('click', onModelClick);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.target === button) mobileIntersection = entry.isIntersecting; });
        schedule();
      }, {threshold: [0, .35, 1]});
      observer.observe(button);
      if (footer) observer.observe(footer);
    }
    const mutation = new MutationObserver(schedule);
    mutation.observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
    controllers.set(root, () => {
      cancelAnimationFrame(frame); observer?.disconnect(); mutation.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', onPageShow);
      window.visualViewport?.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      desktop.removeEventListener('change', onViewport);
      form?.removeEventListener('submit', onSubmit);
      modelLink?.removeEventListener('click', onModelClick);
      controllers.delete(root);
    });
    schedule();
  }
  const init = () => document.querySelectorAll('[data-mry-product]').forEach(initialize);
  window.FXLDesktopPurchaseCard = {init};
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
